import React, { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { BookType } from '../../../ui/src/common/book/BookHelpers';
import { BookLayoutStatus } from '../../../ui/src/common/enums/enums';
import ErrorAppNew from '../../../ui/src/layouts/components/ErrorApp/ErrorAppNew';
import { LayoutProvider, useLayoutContext } from '../../../ui/src/layouts/LayoutContext';
import { BookProvider } from './BookContext';
import BookViewCustom from './theme/global-success-23/BookViewCustom';
import MyLittleFunBookWaitingScreenView from './theme/my-little-fun/MyLittleFunBookWaitingScreenView';
import BookViewNormal from './theme/normal/BookViewNormal';
import SachMemView from './theme/sachmem/SachMemView';

const Book: React.FC<{ bookData: any }> = ({ bookData }) => {
  const [book, setBook] = useState<any>(bookData);
  const layoutProvider = useLayoutContext();
  // console.log(bookData)

  const renderLayout = (layoutStatus: BookLayoutStatus) => {
    switch (layoutStatus) {
      case BookLayoutStatus.GlobalSuccess23:
        return <BookViewCustom />;
      case BookLayoutStatus.MyLittleFun:
        return <MyLittleFunBookWaitingScreenView />;
      default:
        return (
          <div className="container book-page">
            <BookViewNormal />
          </div>
        );
    }
  };
  useEffect(() => {
    if (!book) {
      return;
    }

    if (book?.bookInfo?.css) {
      let head = document.head;
      let style = document.createElement('style');
      let styleText = document.createTextNode(book.bookInfo.css);
      style.appendChild(styleText);
      head.appendChild(style);

      return () => {
        head.removeChild(style);
      };
    }
  }, [book]);

  return (
    <>
      <div
        className={`${layoutProvider.width > layoutProvider.height
          ? 'screen-horizontal'
          : 'screen-vertical'
          }`}
      >
        {book.type === BookType.SGKTiengAnh ? (
          <SachMemView book={book} />
        ) : (
          <BookProvider book={book} setBook={setBook}>
            {renderLayout(book.bookInfo.layoutStatus)}
          </BookProvider>
        )}
      </div>
    </>
  );
};

const BookSSR: React.FC<{ bookData: any }> = ({ bookData }) => {
  return (
    <>
      <BrowserRouter>
        <ErrorBoundary FallbackComponent={ErrorAppNew}>
          <LayoutProvider>
            <Routes>
              <Route path="/books/:id" element={<Book bookData={bookData} />} />
              <Route path="/books/:id/:chapterId" element={<Book bookData={bookData} />} />
            </Routes>
          </LayoutProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </>
  );
};

export default BookSSR;
